
export class GameScheduleInfoModel {
  gameIdentifier: number;
  startTime: string = "00:00:00";
  endTime: string = "00:00:00";
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/business-rules/game-schedule-info.model.ts